<mat-form-field appearance="fill" class="hide-subscript">
  <mat-label>{{ T_SCOPE + '.periods' | translate }}</mat-label>
  <mat-select [(value)]="selectedPeriod" [disabled]="isLoading">
    <mat-option *ngFor="let period of periods" [value]="period">{{
      T_SCOPE + '.period.' + period.keyLabel | translate : { number: period.numberParam }
    }}</mat-option>
  </mat-select>
</mat-form-field>
